export const last = <T>(arr: readonly T[]) => arr[arr.length - 1]
